import React from 'react';
import styled from 'styled-components';

import { components } from '@/types/api';

type Hyperlink = components['schemas']['Hyperlink'];

type ExtendedHyperlink = Hyperlink & {
  end?: number;
  positionEnd?: number;
  positionStart?: number;
  start?: number;
};

export const renderTextWithHyperlinks = (
  text: string,
  hyperlinks: ExtendedHyperlink[] = []
): React.ReactNode => {
  if (!hyperlinks.length) return <StyledText>{text}</StyledText>;

  const links = hyperlinks
    .map(h => ({
      url: h.url,
      start: h.position_start ?? h.start ?? h.positionStart,
      end: h.position_end ?? h.end ?? h.positionEnd,
    }))
    .filter(l => l.start != null && l.end != null)
    .sort((a, b) => a.start! - b.start!);

  const out: React.ReactNode[] = [];
  let cursor = 0;

  links.forEach(({ url, start, end }) => {
    if (start! > cursor) {
      out.push(<StyledText key={`txt-${cursor}`}>{text.slice(cursor, start)}</StyledText>);
    }

    out.push(
      <StyledAnchor href={url} target="_blank" rel="noopener noreferrer" key={`lnk-${start}`}>
        {text.slice(start!, end!)}
      </StyledAnchor>
    );

    cursor = end!;
  });

  if (cursor < text.length) {
    out.push(<StyledText key={`txt-${cursor}`}>{text.slice(cursor)}</StyledText>);
  }

  return out;
};

const StyledAnchor = styled.a`
  display: inline;
  color: #169fe8;
  text-decoration: underline;
  font-size: inherit;
  line-height: inherit;
  letter-spacing: inherit;
  word-break: break-word;
  white-space: pre-wrap;
`;

const StyledText = styled.span`
  display: inline;
  font-size: 1.4rem;
  line-height: 1.5;
  letter-spacing: 0.1px;
  color: #6b6b6b;
  word-break: break-word;
  white-space: pre-wrap;
`;
